<div>
  <div class="hero" [responsiveBackgroundImage]="backgroundImage">
    <!-- <div>
      <div class="image">
        <img src="/assets/tytnetwork-light-shadow.png" />
        <div class="tagline">7 Billion Views | 6 Million Subscribers</div>
      </div>
      <div class="flex-spacer"></div>

    </div> -->
  </div>

  <div>
    <div *ngIf="!applePayInProgress">
      <div class="payment-container" *ngIf="offer; else spinner">

        <noscript>
          <div>
            <h1>Payment</h1>

            <br/>
            <div class="alert alert-danger">
              We use Javascript to send your credit card details directly to our credit card processor.
              This ensures that your credit card is handled securely.
              Please enable Javascript to sign up for TYT membership.
            </div>
            <br/>

            <div class="actions">
              <form method="GET">
                <button class="btn btn-primary">Try Again</button>
                <a class="btn btn-primary" href="/">Back</a>
              </form>
            </div>
          </div>
        </noscript>

        <div *ngIf="clientLoaded">

          <app-form #form [handler]="this" *ngIf="!submitting" class="script-off" [class.script-off]="false" action="/payment" [handler]="this">

            <!-- <div class="flex-container"> -->

              <div class="form-payment">
                <div class="form-title">
                  <p>Step 2 of 2</p>
                  <h3>Your Membership</h3>
                </div>

                <br/>

                <div class="membership-product-display">
                    <span>TYT <app-plus-tag></app-plus-tag></span>
                    <span>{{capitalizeFirstLetter(membershipProduct.name)}} / Billed {{capitalizeFirstLetter(membershipProduct.period)}}</span>
                    <div [innerHTML]="offer.benefits | trustHtml" class="offer-benefits"></div>
                </div>
                <div class="total-price">
                  <p class="price-text">{{offer.dollar_price | currency:'USD'}}</p>
                  <p class="total-text"><a href="/offers/{{offerSetUUID}}">Change your plan</a></p>
                </div>
                <br/>
                <br/>

                <error-message [producer]="this"></error-message>
                <div *ngIf="applePay; else creditCardPay" class="applePay">
                  <button type="button" class="apple-pay-button" (click)="purchaseWithApplePay()">
                    <i class="fa fa-apple" aria-hidden="true"></i>
                    <span>Pay</span>
                  </button>
                  <a (click)="togglePaymentType()">Pay with credit card instead</a>
                </div>
                <ng-template #creditCardPay>
                  <div class="card-payment">

                    <div class="payment-method">
                      <p>Payment Method</p>

                      <div class="cc-icons">
                        <i class="fa fa-cc-amex" aria-hidden="true"></i>
                        <i class="fa fa-cc-visa" aria-hidden="true"></i>
                        <i class="fa fa-cc-mastercard" aria-hidden="true"></i>
                        <i class="fa fa-cc-discover" aria-hidden="true"></i>
                      </div>

                    </div>

                    <!-- <div class="full-name">
                      <div class="form-group">
                        <label for="first-name">First Name</label>
                        <input errorHighlight type="text" class="form-control" id="first-name" name="first-name" [(ngModel)]="firstName" required>
                      </div>
                      <div class="form-group">
                        <label for="last-name">Last Name</label>
                        <input errorHighlight type="text" class="form-control" id="last-name" name="last-name" [(ngModel)]="lastName" required>
                      </div>
                    </div> -->
                    <div class="form-group fields">
                      <label for="cardholder-name">Cardholder Name</label>
                      <input errorHighlight type="text" class="form-control" id="cardholder-name" name="cardholder-name" [(ngModel)]="cardholderName" required>
                    </div>
                    <div class="form-group credit-card fields">
                      <i *ngIf="cardBrandIcon" class="fa fa-{{cardBrandIcon || 'credit-card'}} brand" aria-hidden="true"></i>
                      <label for="cc-number">Credit Card Number</label>
                      <input #ccElement errorHighlight type="text" class="form-control" id="cc-number" name="cc-number" autocomplete="cc-number"
                        (change)="updateCardBrand()" (keyup)="updateCardBrand()" [(ngModel)]="creditCard">
                    </div>

                    <div class="card-exp-cvc fields">

                      <div class="form-group expiration">
                        <label for="expiration">Expiration</label>
                        <input errorHighlight type="text" placeholder="MM/YYYY" class="form-control" name="cc-exp" [(ngModel)]="expiration" title="If you have trouble with expiration dates, try using the full year (ie 2021)" required>
                        <!-- &nbsp;&nbsp; MM/YYYY -->
                      </div>

                      <div class="form-group cvc">
                        <label for="cvc">CVC</label>
                        <input errorHighlight type="text" class="form-control" name="cc-csc" [(ngModel)]="cvc" required placeholder="CVC">

                        <a href="https://www.cvvnumber.com/cvv.html" target="_blank" class="card-tooltip">What is this?
                          <span class="tooltiptext">
                            The CVV Number ("Card Verification Value") on your credit card or debit card is a 3 digit number on VISA®, MasterCard® and
                            Discover® branded credit and debit cards. On your American Express® branded credit or debit card it is a 4
                            digit numeric code.
                          </span>
                        </a>
                      </div>

                      <div class="form-group zipcode">
                        <label for="cvc">Zipcode</label>
                        <input errorHighlight type="text" class="form-control" name="cc-zipcode" [(ngModel)]="address_zip" required placeholder="Zipcode">
                      </div>
                    </div>

                  </div>

                  <div *ngIf="validityError" class="alert alert-danger">
                    <strong>An issue occurred processing your request. Please check the information above.</strong>
                    <ul>
                      <li>Ensure your credit card details are correct.</li>
                      <li>Gifts cannot currently be sent to existing TYT members.</li>
                      <li>Ensure that your email and the recipient email are correct.</li>
                    </ul>
                  </div>

                  <br/>
                  <div class="purchase-info">
                    Your account will be billed {{offer.dollar_price | currency:'USD'}} each {{offer.period === 'monthly' ? 'month' : 'year'}} until you cancel. Cancel at any time.
                  </div>
                  <!-- <button *ngIf="!submitting" type="submit" class="btn btn-success">Purchase Membership</button> -->
                  <app-form-submit-button *ngIf="!submitting">Purchase</app-form-submit-button>
                </ng-template>
              </div>
            <!-- </div> -->

          </app-form>

          <div *ngIf="submitting" style="text-align: center;">
            <app-spinner></app-spinner>
            <div>Please wait...</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #spinner>
    <div style="text-align: center;">
      <app-spinner></app-spinner>
      <div>Please wait...</div>
    </div>
  </ng-template>
  <div *ngIf="!applePayInProgress" class="backButton" routerLink="/profile">Back</div>
</div>
